import { translate } from 'react-i18next';
// Services
import { getTranslateDocSpecialties } from 'src/views/practitioner/services/appointments';
// Components
import { SelectField } from 'components/Fields';
// Styles & Images
import DefaultPractitioner from 'assets/images/default-practitioner.svg';
import { DropDownItem } from '../../styles';

const addNameToPractitionerList = (practitionersList, i18n) =>
  Array.isArray(practitionersList) &&
  practitionersList.map(el => {
    const translate = el.localizations && el.localizations.find(e => e.lang === i18n.language);
    el.name = translate && translate.name;
    return el;
  });

const ListItem = ({ item }) => (
  <DropDownItem>
    <div className="photo-wrapper">
      <img src={item.photo || DefaultPractitioner} alt="practitioner"/>
    </div>
    <div className="practitioner">
      <p>{item.name || ''}</p>
      <p className="specialties">{getTranslateDocSpecialties(item)}</p>
    </div>
  </DropDownItem>
);

const ValueItem = ({ item }) => (
  <DropDownItem>
    <div className="photo-wrapper">
      <img src={item.photo || DefaultPractitioner} alt="practitioner"/>
    </div>
    <div className="practitioner">
      <p className="now-wrap">{item.name || ''}</p>
      <p className="specialties now-wrap">{getTranslateDocSpecialties(item)}</p>
    </div>
  </DropDownItem>
);

export default translate()(props => {
  const { disabled, practitioners, practitionerId, onChangePractitioner, i18n } = props;
  const practitionersWithName = addNameToPractitionerList(practitioners, i18n);

  return practitionersWithName ? (
    <SelectField
      style={{ marginTop: '0px' }}
      filter="contains"
      data={practitionersWithName}
      input={{ disabled: disabled }}
      value={
        practitionersWithName.find(item => item.id === practitionerId) || practitionersWithName[0]
      }
      textField="name"
      valueField="id"
      valueComponent={ValueItem}
      itemComponent={ListItem}
      messages={{
        emptyFilter: i18n.t('no_result_found_placeholder'),
        filterPlaceholder: i18n.t('search_practitioner_placeholder')
      }}
      onChange={onChangePractitioner}
    />
  ) : null;
});
